module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8RvGI"))).then(() => parcelRequire('cvs7o'));